module.exports = __webpack_public_path__ + "static/media/320.bd46b953.wav";